var render = function render(){var _vm=this,_c=_vm._self._c;return _c('WsStateDropdownRadio001',{attrs:{"dropdown-menu-item":_vm.items,"placeholder":_vm.placeholder,"outline":""},model:{value:(_vm.state),callback:function ($$v) {_vm.state=$$v},expression:"state"}})
}
var staticRenderFns = []

export { render, staticRenderFns }